import * as i from "react";
import { l, s as x, R as V, L as j } from "./contexts-DzwYztG5.mjs";
import { Room as U, RoomEvent as a, MediaDeviceFailure as _ } from "livekit-client";
function M(n) {
  var e, t, o = "";
  if (typeof n == "string" || typeof n == "number") o += n;
  else if (typeof n == "object") if (Array.isArray(n)) {
    var r = n.length;
    for (e = 0; e < r; e++) n[e] && (t = M(n[e])) && (o && (o += " "), o += t);
  } else for (t in n) n[t] && (o && (o += " "), o += t);
  return o;
}
function F() {
  for (var n, e, t = 0, o = "", r = arguments.length; t < r; t++) (n = arguments[t]) && (e = M(n)) && (o && (o += " "), o += e);
  return o;
}
function I(...n) {
  return (...e) => {
    for (const t of n)
      if (typeof t == "function")
        try {
          t(...e);
        } catch (o) {
          console.error(o);
        }
  };
}
function L(...n) {
  const e = { ...n[0] };
  for (let t = 1; t < n.length; t++) {
    const o = n[t];
    for (const r in o) {
      const f = e[r], c = o[r];
      typeof f == "function" && typeof c == "function" && // This is a lot faster than a regex.
      r[0] === "o" && r[1] === "n" && r.charCodeAt(2) >= /* 'A' */
      65 && r.charCodeAt(2) <= /* 'Z' */
      90 ? e[r] = I(f, c) : (r === "className" || r === "UNSAFE_className") && typeof f == "string" && typeof c == "string" ? e[r] = F(f, c) : e[r] = c !== void 0 ? c : f;
    }
  }
  return e;
}
function J(n) {
  return n !== void 0;
}
function G(...n) {
  return L(...n.filter(J));
}
function H(n, e, t) {
  return i.Children.map(n, (o) => i.isValidElement(o) && i.Children.only(n) ? (o.props.className && (e ?? (e = {}), e.className = F(o.props.className, e.className), e.style = { ...o.props.style, ...e.style }), i.cloneElement(o, { ...e, key: t })) : o);
}
function Q(n) {
  if (typeof window < "u" && typeof process < "u" && // eslint-disable-next-line turbo/no-undeclared-env-vars
  (process?.env?.NODE_ENV === "dev" || // eslint-disable-next-line turbo/no-undeclared-env-vars
  process?.env?.NODE_ENV === "development")) {
    const e = document.querySelector(".lk-room-container");
    e && !getComputedStyle(e).getPropertyValue("--lk-has-imported-styles") && l.warn(
      "It looks like you're not using the `@livekit/components-styles package`. To render the UI with the default styling, please import it in your layout or page."
    );
  }
}
function T(n, e) {
  return n === "processor" && e && typeof e == "object" && "name" in e ? e.name : (n === "e2ee" || n === "encryption") && e ? "e2ee-enabled" : e;
}
const q = {
  connect: !0,
  audio: !1,
  video: !1
};
function $(n) {
  const {
    token: e,
    serverUrl: t,
    options: o,
    room: r,
    connectOptions: f,
    connect: c,
    audio: p,
    video: y,
    screen: g,
    onConnected: b,
    onDisconnected: C,
    onError: m,
    onMediaDeviceFailure: R,
    onEncryptionError: w,
    simulateParticipants: E,
    ...N
  } = { ...q, ...n };
  o && r && l.warn(
    "when using a manually created room, the options object will be ignored. set the desired options directly when creating the room instead."
  );
  const [s, A] = i.useState(), h = i.useRef(c);
  i.useEffect(() => {
    A(r ?? new U(o));
  }, [r, JSON.stringify(o, T)]);
  const O = i.useMemo(() => {
    const { className: d } = x();
    return L(N, { className: d });
  }, [N]);
  return i.useEffect(() => {
    if (!s) return;
    const d = () => {
      const u = s.localParticipant;
      l.debug("trying to publish local tracks"), Promise.all([
        u.setMicrophoneEnabled(!!p, typeof p != "boolean" ? p : void 0),
        u.setCameraEnabled(!!y, typeof y != "boolean" ? y : void 0),
        u.setScreenShareEnabled(!!g, typeof g != "boolean" ? g : void 0)
      ]).catch((v) => {
        l.warn(v), m?.(v);
      });
    }, P = (u, v) => {
      const K = _.getFailure(u);
      R?.(K, v);
    }, S = (u) => {
      w?.(u);
    }, k = (u) => {
      C?.(u);
    }, D = () => {
      b?.();
    };
    return s.on(a.SignalConnected, d).on(a.MediaDevicesError, P).on(a.EncryptionError, S).on(a.Disconnected, k).on(a.Connected, D), () => {
      s.off(a.SignalConnected, d).off(a.MediaDevicesError, P).off(a.EncryptionError, S).off(a.Disconnected, k).off(a.Connected, D);
    };
  }, [
    s,
    p,
    y,
    g,
    m,
    w,
    R,
    b,
    C
  ]), i.useEffect(() => {
    if (s) {
      if (E) {
        s.simulateParticipants({
          participants: {
            count: E
          },
          publish: {
            audio: !0,
            useRealTracks: !0
          }
        });
        return;
      }
      if (c) {
        if (h.current = !0, l.debug("connecting"), !e) {
          l.debug("no token yet");
          return;
        }
        if (!t) {
          l.warn("no livekit url provided"), m?.(Error("no livekit url provided"));
          return;
        }
        s.connect(t, e, f).catch((d) => {
          l.warn(d), h.current === !0 && m?.(d);
        });
      } else
        l.debug("disconnecting because connect is false"), h.current = !1, s.disconnect();
    }
  }, [
    c,
    e,
    JSON.stringify(f),
    s,
    m,
    t,
    E
  ]), i.useEffect(() => {
    if (s)
      return () => {
        l.info("disconnecting on onmount"), s.disconnect();
      };
  }, [s]), { room: s, htmlProps: O };
}
const W = /* @__PURE__ */ i.forwardRef(function(e, t) {
  const { room: o, htmlProps: r } = $(e);
  return /* @__PURE__ */ i.createElement("div", { ref: t, ...r }, o && /* @__PURE__ */ i.createElement(V.Provider, { value: o }, /* @__PURE__ */ i.createElement(j.Provider, { value: e.featureFlags }, e.children)));
});
export {
  W as L,
  G as a,
  H as c,
  L as m,
  T as r,
  $ as u,
  Q as w
};
//# sourceMappingURL=room-Q0GUQkyk.mjs.map
